unit SystemSetupVatSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmSystemVatSetup = class(TForm)
    WebPanel1: TPanel;
    btnOk: TButton;
    btnCancel: TButton;
    WebLabel96: TLabel;
    WebLabel95: TLabel;
    WebDBEdit35: TDBEdit;
    WebLabel97: TLabel;
    WebPanel2: TPanel;
    WebDBDateTimePicker1: TDBDateTimePicker;
    WebDBDateTimePicker2: TDBDateTimePicker;
    dsVattable: TDataSource;
  private
    { Private declarations }
  public
    { Public declarations }
    iState : integer;
  protected procedure LoadDFMValues; override; end;

var
  frmSystemVatSetup: TfrmSystemVatSetup;

implementation

{$R *.dfm}

procedure TfrmSystemVatSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel96 := TLabel.Create(Self);
  WebLabel95 := TLabel.Create(Self);
  WebLabel97 := TLabel.Create(Self);
  btnOk := TButton.Create(Self);
  btnCancel := TButton.Create(Self);
  WebDBEdit35 := TDBEdit.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebDBDateTimePicker1 := TDBDateTimePicker.Create(Self);
  WebDBDateTimePicker2 := TDBDateTimePicker.Create(Self);
  dsVattable := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel96.BeforeLoadDFMValues;
  WebLabel95.BeforeLoadDFMValues;
  WebLabel97.BeforeLoadDFMValues;
  btnOk.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  WebDBEdit35.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebDBDateTimePicker1.BeforeLoadDFMValues;
  WebDBDateTimePicker2.BeforeLoadDFMValues;
  dsVattable.BeforeLoadDFMValues;
  try
    Name := 'frmSystemVatSetup';
    Width := 623;
    Height := 248;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 623;
    WebPanel1.Height := 248;
    WebPanel1.Align := alClient;
    WebPanel1.ChildOrder := 6;
    WebPanel1.TabOrder := 0;
    WebLabel96.SetParentComponent(WebPanel1);
    WebLabel96.Name := 'WebLabel96';
    WebLabel96.Left := 178;
    WebLabel96.Top := 139;
    WebLabel96.Width := 54;
    WebLabel96.Height := 15;
    WebLabel96.Caption := 'Start Date:';
    WebLabel96.HeightPercent := 100.000000000000000000;
    WebLabel96.WidthPercent := 100.000000000000000000;
    WebLabel95.SetParentComponent(WebPanel1);
    WebLabel95.Name := 'WebLabel95';
    WebLabel95.Left := 16;
    WebLabel95.Top := 139;
    WebLabel95.Width := 29;
    WebLabel95.Height := 15;
    WebLabel95.Caption := 'Vat%:';
    WebLabel95.HeightPercent := 100.000000000000000000;
    WebLabel95.WidthPercent := 100.000000000000000000;
    WebLabel97.SetParentComponent(WebPanel1);
    WebLabel97.Name := 'WebLabel97';
    WebLabel97.Left := 424;
    WebLabel97.Top := 139;
    WebLabel97.Width := 50;
    WebLabel97.Height := 15;
    WebLabel97.Caption := 'End Date:';
    WebLabel97.HeightPercent := 100.000000000000000000;
    WebLabel97.WidthPercent := 100.000000000000000000;
    btnOk.SetParentComponent(WebPanel1);
    btnOk.Name := 'btnOk';
    btnOk.Left := 164;
    btnOk.Top := 66;
    btnOk.Width := 96;
    btnOk.Height := 25;
    btnOk.Caption := 'ok';
    btnOk.HeightPercent := 100.000000000000000000;
    btnOk.WidthPercent := 100.000000000000000000;
    btnCancel.SetParentComponent(WebPanel1);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 368;
    btnCancel.Top := 66;
    btnCancel.Width := 96;
    btnCancel.Height := 25;
    btnCancel.Caption := 'cancel';
    btnCancel.ChildOrder := 1;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.WidthPercent := 100.000000000000000000;
    WebDBEdit35.SetParentComponent(WebPanel1);
    WebDBEdit35.Name := 'WebDBEdit35';
    WebDBEdit35.Left := 16;
    WebDBEdit35.Top := 160;
    WebDBEdit35.Width := 121;
    WebDBEdit35.Height := 22;
    WebDBEdit35.ChildOrder := 2;
    WebDBEdit35.HeightPercent := 100.000000000000000000;
    WebDBEdit35.Text := 'WebDBEdit35';
    WebDBEdit35.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 623;
    WebPanel2.Height := 41;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'VAT % Setup';
    WebPanel2.ChildOrder := 6;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 3;
    WebDBDateTimePicker1.SetParentComponent(WebPanel1);
    WebDBDateTimePicker1.Name := 'WebDBDateTimePicker1';
    WebDBDateTimePicker1.Left := 178;
    WebDBDateTimePicker1.Top := 160;
    WebDBDateTimePicker1.Width := 170;
    WebDBDateTimePicker1.Height := 22;
    WebDBDateTimePicker1.BorderStyle := bsSingle;
    WebDBDateTimePicker1.ChildOrder := 7;
    WebDBDateTimePicker1.Color := clWhite;
    WebDBDateTimePicker1.Date := 45720.756263495370000000;
    WebDBDateTimePicker1.Role := '';
    WebDBDateTimePicker1.Text := '';
    WebDBDateTimePicker2.SetParentComponent(WebPanel1);
    WebDBDateTimePicker2.Name := 'WebDBDateTimePicker2';
    WebDBDateTimePicker2.Left := 424;
    WebDBDateTimePicker2.Top := 160;
    WebDBDateTimePicker2.Width := 170;
    WebDBDateTimePicker2.Height := 22;
    WebDBDateTimePicker2.BorderStyle := bsSingle;
    WebDBDateTimePicker2.ChildOrder := 8;
    WebDBDateTimePicker2.Color := clWhite;
    WebDBDateTimePicker2.Date := 45720.756277581020000000;
    WebDBDateTimePicker2.Role := '';
    WebDBDateTimePicker2.Text := '';
    dsVattable.SetParentComponent(Self);
    dsVattable.Name := 'dsVattable';
    dsVattable.Left := 120;
    dsVattable.Top := 60;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel96.AfterLoadDFMValues;
    WebLabel95.AfterLoadDFMValues;
    WebLabel97.AfterLoadDFMValues;
    btnOk.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    WebDBEdit35.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebDBDateTimePicker1.AfterLoadDFMValues;
    WebDBDateTimePicker2.AfterLoadDFMValues;
    dsVattable.AfterLoadDFMValues;
  end;
end;

end.
